/**
 * Phase B — compact connectivity/sync badge for the mobile header.
 * Hidden when online with an empty queue; tap to open the Sync Status page.
 */
import React from 'react';
import { CloudOff, RefreshCw, CheckCircle2, CloudUpload } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useNetworkStatus } from '../hooks/useNetworkStatus';

export default function OfflineIndicator() {
  const { online, pending, syncing, justSynced } = useNetworkStatus();
  const navigate = useNavigate();

  if (online && pending === 0 && !syncing && !justSynced) return null;

  let content;
  let cls;
  let testid;
  if (!online) {
    content = <><CloudOff size={13} /> Offline{pending > 0 ? ` · ${pending}` : ''}</>;
    cls = 'bg-amber-100 text-amber-800 border-amber-300';
    testid = 'offline-indicator-offline';
  } else if (syncing) {
    content = <><RefreshCw size={13} className="animate-spin" /> Syncing…</>;
    cls = 'bg-teal-100 text-teal-800 border-teal-300';
    testid = 'offline-indicator-syncing';
  } else if (pending > 0) {
    content = <><CloudUpload size={13} /> {pending} pending</>;
    cls = 'bg-teal-100 text-teal-800 border-teal-300';
    testid = 'offline-indicator-pending';
  } else {
    content = <><CheckCircle2 size={13} /> Synced</>;
    cls = 'bg-emerald-100 text-emerald-800 border-emerald-300';
    testid = 'offline-indicator-synced';
  }

  return (
    <button
      type="button"
      onClick={() => navigate('/m/sync')}
      data-testid={testid}
      className={`flex items-center gap-1 px-2.5 py-1 rounded-full border text-[10px] font-display font-bold uppercase tracking-wider transition active:scale-95 ${cls}`}
    >
      {content}
    </button>
  );
}
